<template>
  <div class="mini-kasko-order__group mini-kasko-order__group--wide">
    <h2 class="mini-kasko-order__group-title">Місце проживання страхувальника</h2>
    <div class="mini-kasko-order__group-grid">
      <div class="mini-kasko-order__field">
        <span>Місто</span>
        <MiniKaskoCityField
          ref="city_id"
          :value="value.city_id"
          :selected-label="value.city_name"
          :disabled="isDeclared"
          :error="errors.city_id"
          @input="handleCityInput"
          @change="handleCityChange"
        />
      </div>
      <label class="mini-kasko-order__field">
        <span>Вулиця</span>
        <input
          ref="street"
          :value="value.street"
          :class="{ 'mini-kasko-order__input--invalid': Boolean(errors.street) }"
          type="text"
          :readonly="isDeclared"
          @input="emitFieldInput('street', $event)"
        >
        <small v-if="errors.street" class="mini-kasko-order__field-error">{{ errors.street }}</small>
      </label>
      <label class="mini-kasko-order__field">
        <span>Будинок</span>
        <input
          ref="house"
          :value="value.house"
          :class="{ 'mini-kasko-order__input--invalid': Boolean(errors.house) }"
          type="text"
          :readonly="isDeclared"
          @input="emitFieldInput('house', $event)"
        >
        <small v-if="errors.house" class="mini-kasko-order__field-error">{{ errors.house }}</small>
      </label>
      <label class="mini-kasko-order__field">
        <span>Квартира</span>
        <input
          ref="apartment"
          :value="value.apartment"
          :class="{ 'mini-kasko-order__input--invalid': Boolean(errors.apartment) }"
          type="text"
          :readonly="isDeclared"
          @input="emitFieldInput('apartment', $event)"
        >
        <small v-if="errors.apartment" class="mini-kasko-order__field-error">{{ errors.apartment }}</small>
      </label>
    </div>
  </div>
</template>

<script>
import MiniKaskoCityField from "@/views/miniKasko/components/MiniKaskoCityField.vue";

export default {
  name: 'MiniKaskoAddressForm',
  components: {MiniKaskoCityField},
  props: {
    value: {
      type: Object,
      required: true,
    },
    isDeclared: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    buildNextValue(field, value) {
      return {
        ...this.value,
        [field]: value,
      };
    },
    emitFieldInput(field, event) {
      const value = String(event?.target?.value || '').trim();

      this.$emit('input', this.buildNextValue(field, value));
      this.$emit('field-change', field);
    },
    handleCityInput(value) {
      this.$emit('input', this.buildNextValue('city_id', value));
      this.$emit('field-change', 'city_id');
    },
    handleCityChange(city) {
      this.$emit('input', {
        ...this.value,
        city_id: city?.id || this.value.city_id,
        city_name: city?.name_full_name_ua || '',
      });
      this.$emit('field-change', 'city_id');
    },
    focus(field) {
      const input = this.$refs[field];

      if (!input) {
        return false;
      }

      if (typeof input.focus === 'function') {
        input.focus();
        return true;
      }

      if (typeof input.scrollIntoView === 'function') {
        input.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }

      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.mini-kasko-order {
  &__group {
    display: flex;
    flex-direction: column;
    gap: 12px;

    &--wide {
      grid-column: span 2;
    }
  }

  &__group-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px 16px;
  }

  &__group-title {
    font-size: 18px;
    line-height: 24px;
    font-weight: 600;
  }

  &__field {
    display: flex;
    flex-direction: column;
    gap: 6px;

    span {
      font-size: 13px;
      line-height: 18px;
      color: #52525b;
    }

    input {
      width: 100%;
      min-height: 44px;
      padding: 10px 12px;
      border: 1px solid #cbd5e1;
      border-radius: 8px;
      background: #fff;
      outline: none;
      transition: border-color 0.2s ease, box-shadow 0.2s ease;

      &:focus {
        border-color: #fb923c;
        box-shadow: 0 0 0 3px rgba(251, 146, 60, 0.15);
      }

      &[readonly],
      &:disabled {
        background: #f8fafc;
        color: #52525b;
        cursor: default;
      }
    }

    .mini-kasko-order__input--invalid {
      border-color: #ef4444;

      &:focus {
        border-color: #ef4444;
        box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.12);
      }
    }
  }

  &__field-error {
    color: #dc2626;
    font-size: 12px;
    line-height: 16px;
  }

  @media (max-width: 960px) {
    &__group-grid {
      grid-template-columns: 1fr;
    }

    &__group--wide {
      grid-column: span 1;
    }
  }
}
</style>
